module.exports = "data:image/png;base64,"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/fenzi.png
// module id = HzBk
// module chunks = 16